/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type WebAppWorkingHours_viewer = {
    readonly user: {
        readonly orgs: {
            readonly edges: ReadonlyArray<{
                readonly node: {
                    readonly userWorkingHours: {
                        readonly workingHours: {
                            readonly " $fragmentRefs": FragmentRefs<"DraggableWorkingHours_workingHours">;
                        } | null;
                    } | null;
                } | null;
            } | null> | null;
        };
    } | null;
    readonly " $refType": "WebAppWorkingHours_viewer";
};
export type WebAppWorkingHours_viewer$data = WebAppWorkingHours_viewer;
export type WebAppWorkingHours_viewer$key = {
    readonly " $data"?: WebAppWorkingHours_viewer$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"WebAppWorkingHours_viewer">;
};



const node: ReaderFragment = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "WebAppWorkingHours_viewer",
    "selections": [
        {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "first",
                            "value": 1000000
                        }
                    ],
                    "concreteType": "OrgConnection",
                    "kind": "LinkedField",
                    "name": "orgs",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "OrgEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Org",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": [
                                                {
                                                    "kind": "Literal",
                                                    "name": "resolveOverrides",
                                                    "value": false
                                                }
                                            ],
                                            "concreteType": "UserWorkingHours",
                                            "kind": "LinkedField",
                                            "name": "userWorkingHours",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "WorkingHours",
                                                    "kind": "LinkedField",
                                                    "name": "workingHours",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "args": null,
                                                            "kind": "FragmentSpread",
                                                            "name": "DraggableWorkingHours_workingHours"
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": "userWorkingHours(resolveOverrides:false)"
                                        }
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": "orgs(first:1000000)"
                }
            ],
            "storageKey": null
        }
    ],
    "type": "Viewer",
    "abstractKey": null
} as any;
(node as any).hash = 'bb8666bcd9f185d127d2b60a82b909b4';
export default node;
